import { ShowConsentBannerUseCase } from './core'
import { VisibilityAdapter } from './adapters'
import { IS_APP } from './singletons'

const hideConsentBannerPaths = [
  '/agb',
  '/datenschutz',
  '/impressum',
  '/datenschutzinformationen_otto_payments',
]

export const showConsentBannerUseCase = new ShowConsentBannerUseCase(
  new VisibilityAdapter(hideConsentBannerPaths, { isApp: IS_APP }),
  IS_APP
)
